<!-- 理论考试 -->
<template>
    <div class="theoryTest">
        <el-row class="tableHearInputBox" type="flex">
            <el-col>
                <el-select v-model="query.applicationYear" @change="freshLoad" filterable placeholder="请选择">
                    <el-option label="全部年份" value=""></el-option>
                    <el-option v-for="item in applicationFilterYearList" :key="item.value" :label="item.label + '年'"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select style="margin-left: 10px;width: 160px" v-model="query.hasLock" @change="freshLoad" filterable
                    placeholder="请选择">
                    <el-option label="全部科目状态" value=""></el-option>
                    <el-option label="科目状态（正常）" :value="0"></el-option>
                    <el-option label="科目状态（锁定）" :value="1"></el-option>
                </el-select>
            </el-col>
            <!-- <Debounce> -->
                <!-- <el-button type="primary" v-if="$roleFilter('process:generateTheory')"
                    @click="showDialog('createCertificate')" size="small">生成证书</el-button> -->
            <!-- </Debounce> -->
            <Debounce>
        <el-button
          type="primary"
          @click="showDialog1"
          size="small"
          v-if="getTableRole"
        >
          设置发证日期</el-button
        >
      </Debounce>
            <Debounce>
                <el-button type="primary" v-if="getTableRole" @click="showDialog('scoreQuery')"
                    size="small">开放成绩查询</el-button>
            </Debounce>
            <Debounce>
                <el-button type="primary" v-if="getTableRole"
                    @click="showDialog('modifyInformation')" size="small">开放考生修改信息</el-button>
            </Debounce>
            <Debounce>
                <el-button type="primary" v-if="getTableRole" @click="showDialog('lock')"
                    size="small">锁定考试科目</el-button>
            </Debounce>
        </el-row>
        <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
            :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
            @selection-change="handleSelectionChange" :height="$store.getters.getTableHeight - 50">
            <el-table-column type="selection" align="center" width="40"></el-table-column>
            <el-table-column prop="subjectName" label="考试科目" align="center" :min-width="150"></el-table-column>
            <el-table-column label="考试年份" align="center" :min-width="60">
                <template slot-scope="scope">
                    {{ scope.row.appYear + '年' }}
                </template>
            </el-table-column>
            <el-table-column prop="kspc" label="考试批次" align="center">
        <template slot-scope="scope">
          {{ scope.row.kspc === 1 ? "春季" : scope.row.kspc === 2 ? "夏季": scope.row.kspc === 3 ? "秋季" : scope.row.kspc === 4 ? "冬季":''}}
        </template>

      </el-table-column>
            <el-table-column prop="" label="理论考试时间" align="center" :min-width="250">
                <template slot-scope="scope">
                    <p>{{ scope.row.startTime | getTimeByTimestamp }}
                        至
                        {{ scope.row.endTime | getTimeByTimestamp }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="payNum" label="已缴费人数" :min-width="80" align="center"></el-table-column>
        
                <el-table-column label="未考试人数" :min-width="80" align="center">
                <template slot-scope="{ row }">
                    <el-button type="text" @click="getUnLoadList(row.examId)" v-if="row.needExamNum">
                        {{ row.needExamNum }}
                    </el-button>
                    <span v-else>
                        {{ row.needExamNum }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="examNum" label="已考试人数" :min-width="80" align="center"></el-table-column>
    
          
            <el-table-column label="考试详情" :min-width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="goToTheoryTest(scope.row)">考试详情</el-button>
                </template>
            </el-table-column>
            <template v-if="getTableRole">
                <el-table-column label="成绩查询状态" :min-width="110" align="center">
                    <template slot-scope="scope">
                        <span style="color:#8AC404" v-if="scope.row.queryState == 1">已开放</span>
                        <span style="color:#409EFF" v-else>未开放</span>
                    </template>
                </el-table-column>
                <el-table-column label="考生修改信息" :min-width="160" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.showTime">
                            <p>{{ scope.row.modifyTimeStart | getTimeByTimestamp }}</p>
                            <p>至</p>
                            <p>{{ scope.row.modifyTimeEnd | getTimeByTimestamp }}</p>
                        </div>
                        <span style="color:#8AC404" v-else>已关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" :min-width="80" align="center">
                    <template slot-scope="scope">
                        <span style="color:#8AC404" v-if="scope.row.hasLock == 0">正常</span>
                        <span style="color:#409EFF" v-if="scope.row.hasLock == 1">锁定</span>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
            @pagination="tableLoad" />
        <el-dialog custom-class="dailogComponents" title="未考试人数" :visible.sync="visible" :destroy-on-close="true"
            :close-on-click-modal="false" width="860px">
            <div class="dialogBox">
                <!-- 未考试人数列表 -->
                <el-table :data="unLoadList" tooltip-effect="dark" border v-loading="dailogTableLoad" ref="elTable4"
                    style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" element-loading-text="加载中"
                    :height="400">
                    <el-table-column prop="name" label="姓名" width="100" align="center"></el-table-column>
                    <el-table-column prop="password" label="性别" width="50" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.sex == 2 ? '女' : '男' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" width="60" label="年龄" align="center"></el-table-column>
                    <el-table-column prop="idNumber" label="证件号码" width="150" align="center"
                        v-if="showIdNumber"></el-table-column>
                    <el-table-column prop="provinceName" label="省份" width="100" show-overflow-tooltip
                        align="center"></el-table-column>
                    <el-table-column prop="examSiteName" :min-width="100" show-overflow-tooltip label="市级代理"
                        align="center"></el-table-column>
                    <el-table-column prop="registerSiteName" :min-width="130" show-overflow-tooltip label="考点"
                        align="center"></el-table-column>
                    <el-table-column :min-width="80" show-overflow-tooltip label="报考等级" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.subjectLevel | getLvTextByLv }}
                        </template>
                    </el-table-column>
                </el-table>
                <el-row type="flex" class="dailogButBox" justify="center">
                    <Debounce>
                        <el-button size="medium" type="primary" :loading="exportFileLoading"
                            @click="exportNoSubmitInfo">导出</el-button>
                    </Debounce>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog custom-class="dailogComponents" :title="dailogTitle2" :visible.sync="dialogVisibe"
            :before-close="closeDialog" :close-on-click-modal="false"
            :width="dialogType == 'modifyInformation' ? '500px' : '400px'" height="400px" top="25vh">
            <div class="dialogBox">
                <el-form label-width="100px" v-if="dialogType == 'createCertificate'">
                    <el-form-item label="选择日期：">
                        <el-date-picker v-model="form.date" type="date" value-format="yyyy-MM-dd"
                            format="yyyy 年 MM 月 dd 日"></el-date-picker>
                    </el-form-item>
                </el-form>
                <el-form label-width="100px" v-if="dialogType == 'modifyInformation'">
                    <el-form-item label="选择日期：">
                        <el-date-picker v-model="form.datetimerange" unlink-panels type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="options"
                            :default-time="['08:00:00', '23:59:59']" style="width:360px">
                        </el-date-picker>
                    </el-form-item>
                    <p style="text-indent:15px;margin-bottom:10px;color:red" v-if="dialogType == 'modifyInformation'">
                        温馨提示：已选考试科目的考生可以在该时间段内修改个人资料</p>
                </el-form>
                <div v-if="dialogType == 'scoreQuery'" class="content-box">
                    <p>是否开放已选考试科目的成绩查询？开放后，考点/报名点/考生可以在线查询考试成绩和合格证书！</p>
                </div>
                <div v-if="dialogType == 'lock'" class="content-box">
                    <p>是否锁定已选考试科目？锁定后，该考试科目发布信息、报名信息、评分、准考证、考级证书等所有信息都不能再操作，请谨慎操作！</p>
                </div>
                <el-row type="flex" class="dailogButBox" justify="center">
                    <el-button size="medium" @click="closeDialog">取消</el-button>
                    <Debounce>
                        <el-button size="medium" type="primary" @click="confirm(dialogType)">确定</el-button>
                    </Debounce>
                </el-row>
            </div>
        </el-dialog>    <el-dialog
  title="设置发证日期"
  :visible.sync="dialogVisibe1"
  width="18%"
  :before-close="handleClose">
<div style="height: 64px;">
  <div v-if="tableSelectlist.length">
    选择时间：
    <el-date-picker
      v-model="value1"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择时间">
    </el-date-picker>

  </div>
  <div v-else style="text-align:center">
    请勾选未设置发证日期的科目
  </div>
</div>
  <span slot="footer" style="text-align:center">
  
  </span>
  <el-row type="flex" class="dailogButBox" justify="center">

 

          <el-button size="medium" @click="handleClose">取消</el-button>
          <Debounce>
            <el-button type="primary" @click="confirm('setCertificate')">确 定</el-button>
          </Debounce>
        </el-row>
</el-dialog>
    </div>
</template>
  
<script>
//线下
export default {
    name: 'theoryTest',
    props: {
        showIdNumber: {
            type: Boolean,
            default: false,
        },
        showPhone: {
            type: Boolean,
            default: false,
        },
        showScore: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        getTableRole() {
            let { roleIdList, userName } = this.$store.getters.getUser;
            //如果账号为admin/学校管理员角色，则有table的部分列权限
            if (
                userName === 'admin' ||
                (roleIdList && roleIdList.find(item => item === '1'))
            ) {
                return true;
            }
            return false;
        }
    },
    data() {
        return {
            options: {
                disabledDate(v) {
                    return v.getTime() < new Date().getTime() - 86400000;
                },
            },
            tableList: [], dialogVisibe1: false,
      value1:'',
            applicationFilterYearList: [],//年份过滤框
            tableIsLoad: false,
            visible: false,
            dailogTableLoad: false,
            dailogTitle2: "",
            dialogVisibe: false,
            dialogType: "",
            unLoadList: [],
            query: {
                query: "",
                pageNum: 1, // 当前页
                pageSize: 15, // 每页显示条数
                total: 1, //总条数
                applicationYear: "",//考试年份
                hasLock: 0,
            },
            examId: '',
            exportFileLoading: false,
            tableSelectlist: [],
            form: {
                date: "",
                datetimerange: "",
            },
        };
    },
    async mounted() {
        await this.getApplicationFilterYearSelect();
        this.tableLoad();
    },
    methods: {
        handleClose(){
      this.dialogVisibe1=false
      this.value1=''
    },
    showDialog1(){
      if (this.tableSelectlist.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择一条数据！",
        });
        return;
      }
      let subjectIds = [];
        this.tableSelectlist.forEach((item) => {
          subjectIds.push(item.examId);
        });
        console.log(`subjectIds`, subjectIds);
        this.$axios.post(`/process/install/0?fzsj=${this.value1}`, subjectIds).then((res) => {
          if (res.data.code == 10000) {
          console.log(res.data.data);
          if(res.data.data===0){
            this.dialogVisibe1=true
          }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
        showDialog(val) {
            this.dialogType = val;
            if (val && this.tableSelectlist.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请选择一条数据！",
                });
                return;
            }
            if (val == 'scoreQuery') {
                this.dailogTitle2 = "开放成绩查询";
                // if (this.tableSelectlist.findIndex(item => item.queryState === 0 && item.hasPassCert !== 0) == -1)
                // return this.$message.error(`请选择未开放的，且已经生成了考级证书的考试科目！`);
                this.dialogVisibe = true;
            }
            if (val == 'createCertificate') {
                this.dailogTitle2 = "生成证书";
                this.dialogVisibe = true;
            }
            if (val == 'modifyInformation') {
                this.dailogTitle2 = "开放考生修改信息";
                this.dialogVisibe = true;
            }
            if (val == 'lock') {
                this.dailogTitle2 = "锁定考试科目";
                let status = 0;
                let msg = [
                    '',
                    '未开放成绩查询的考试科目不能锁定',
                    '已开放考生修改信息的考试科目不能锁定',
                    '已锁定的考试科目不能再锁定',
                    '考生未生成考级证书的考试科目不能锁定',
                ]
                /**
                 * 锁定条件：
                 * 1，成绩查询已经开放
                 * 2，考试修改信息已关闭
                 * 3，考试已经生成了证书
                 * 4，没被锁定
                 */
                this.tableSelectlist.forEach(item => {
                    //考生修改时间存在，并且当前时间在此范围内
                    if (new Date().getTime() > new Date(item.modifyTimeStart).getTime() && new Date().getTime() < new Date(item.modifyTimeEnd).getTime()) {
                        status = 2;
                    }
                    //考生修改时间已经关闭
                    if (!item.modifyTimeStart && !item.modifyTimeEnd) {
                        status = 0;
                    }
                    //未开放成绩查询
                    if (item.queryState === 0) {
                        status = 1;
                    }
                    //有已经锁定的科目
                    if (item.hasLock === 1) {
                        status = 3;
                    }
                    //未生成了考级证书
                    if (item.hasPassCert === 0) {
                        status = 4;
                    }
                })
                if (status === 0) {
                    this.dialogVisibe = true;
                }
                else {
                    this.$message.error(msg[status])
                }
            }
        },
        closeDialog() {
            this.dialogVisibe = false;
            this.form = {
                data: "",
                datetimerange: "",
            };
        },
        confirm(val) {
            if (val == 'scoreQuery') {
                let examIds = [];
                this.tableSelectlist.forEach(item => {
                    examIds.push(item.examId)
                })
                this.$axios.post("/process/openSocreQuery", examIds).then((res) => {
                    if (res.data.code == 10000) {
                        this.$message.success("开放成绩查询成功");
                        this.tableLoad();
                        this.closeDialog();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }

            if (val == 'createCertificate') {
                let obj = {
                    date: "",
                    examIds: [],
                };
                if (this.form.date === null)
                    return this.$message.error(`请选择日期`);
                obj.date = this.form.date;
                this.tableSelectlist.forEach((item) => {
                    obj.examIds.push(item.examId);
                });
                this.$axios
                    .post("score/generateCert", obj)
                    .then((res) => {
                        if (res.data.code == 10000) {
                            this.$message.success("生成证书成功");
                            this.tableLoad();
                            this.closeDialog();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
            }
            if (val == 'modifyInformation') {
                if (this.form.datetimerange === null)
                    return this.$message.error(`请选择日期`);
                this.dailogTitle2 = "开放考生修改信息";
                let obj = {
                    examIds: [],
                    modifyTimeEnd: this.form.datetimerange[1],
                    modifyTimeStart: this.form.datetimerange[0],
                };
                this.tableSelectlist.forEach(item => {
                    obj.examIds.push(item.examId)
                })
                this.$axios.post("process/openModify", obj).then((res) => {
                    if (res.data.code == 10000) {
                        this.$message.success("操作成功");
                        this.tableLoad();
                        this.closeDialog();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }
            if (val == 'lock') {
                let examIds = [];
                this.tableSelectlist.forEach(item => {
                    examIds.push(item.examId)
                })
                this.$axios.post("process/lock", examIds).then((res) => {
                    if (res.data.code == 10000) {
                        this.$message.success("锁定考试成功");
                        this.tableLoad();
                        this.closeDialog();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }
            if (val == "setCertificate"){
// console.log(this.value1);
let subjectIds = [];
        this.tableSelectlist.forEach((item) => {
          subjectIds.push(item.examId);
        });
        console.log(`subjectIds`, subjectIds);
        this.$axios.post(`/process/install/1?fzsj=${this.value1}`, subjectIds).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success('操作成功');
            this.dialogVisibe1=false
      this.value1=''
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
        },
        handleSelectionChange(val) {
            this.tableSelectlist = val;
        },
        //获取考试年份过滤下拉
        async getApplicationFilterYearSelect() {
            await this.$axios.get("/examInformation/selectFilterData").then((rs) => {
                let appYears = rs.data.data;
                this.applicationFilterYearList = appYears;
                this.query.applicationYear = appYears[0].label;
            });
        },
        freshLoad() {
            this.query.pageNum = 1
            this.tableLoad()
        },
        tableLoad() {
            this.tableIsLoad = true;
            this.$axios.post("/process/theoryList", this.query).then((res) => {
                let { list, total } = res.data.data;
                this.tableList = list;
                this.tableList.forEach(item => {
                    let nowTime = new Date().getTime();
                    let startTime = new Date(item.modifyTimeStart).getTime();
                    let endTime = new Date(item.modifyTimeEnd).getTime();
                    if (nowTime - startTime >= 0 && endTime - nowTime >= 0) {
                        item.showTime = true
                    } else if (startTime == 0 || endTime == 0) {
                        item.showTime = false;
                    } else {
                        item.showTime = false;
                    }
                })
                this.query.total = total;
                this.tableIsLoad = false;
            });
        },
        exportNoSubmitInfo() {
            this.exportFileLoading = true;
            //导出详情
            this.$axios.get("/process/theory/export/" + this.examId, { responseType: 'blob' }).then((res) => {
                console.log(799, res);
                this.$exportFile(res);
                this.exportFileLoading = false;
            });
        },
        //获取未考试列表
        getUnLoadList(rowId) {
            this.unLoadList = []
            this.visible = true;
            this.dailogTableLoad = true;
            this.examId = rowId;
            this.$axios.get("/process/theory/" + rowId).then((res) => {
                let { data, message } = res.data;
                this.dailogTableLoad = false;
                this.unLoadList = data;
            });
        },
        goToTheoryTest(row) {
            this.$emit("goToTheoryTest", row);
        },
    },
};
</script>
<style lang="scss">
.theoryTest {
    .dailogComponents {

        .el-table td div,
        td {
            padding-left: 0px;
            padding-right: 0px;
        }

        .content-box {
            padding: 0 20px 20px;
        }
    }

    .dialogBox {
        padding: 0 20px 20px;
    }

    .el-button--text {
        text-decoration: underline;
    }
}
</style>
  